// Calculate the progress number, and the width of the progress bar.
const calculateProgress = (currentVal, targetVal) => {
    const progressBar = document.querySelectorAll('.cart-shippingThreshold__progress');
    const progressNum = document.querySelectorAll('.cart-shipping__num');
    const progressOuter = document.querySelectorAll('.cart-shipping__numOuter');
    const successMsg = document.querySelectorAll('.cart-shipping__success');
    // calculate how far progress is from the total as a percentage
    const result = Math.round(100 * currentVal / targetVal);
    
    const newProgressNum = (targetVal - currentVal) / 100;
    if(newProgressNum <= 0){
        successMsg.forEach(function(el){
            el.style.display = 'block';
          });
        progressOuter.forEach(function(el){
            el.style.display = 'none';
          });
        progressNum.forEach(function(el){
          el.textContent = newProgressNum;
        });
      } else {
        successMsg.forEach(function(el){
            el.style.display = 'none';
          });
          progressOuter.forEach(function(el){
            el.style.display = 'block';
          });
          progressNum.forEach(function(el){
            el.textContent = newProgressNum;
          });
      }


    progressBar.forEach(function(el){
      el.setAttribute('style', "width: ".concat(result, "%"));
    })
};


$(document).on('cart.requestComplete', function(event, cart) {
    $('#counter').html(cart.item_count);
    let threshold = $('.cart-shippingThreshold__bar').data('threshold')
    calculateProgress(cart.items_subtotal_price , (threshold * 100));
});

$(document).on('cart.ready', function(event, cart) {
  let threshold = $('.cart-shippingThreshold__bar').data('threshold')
  calculateProgress(cart.items_subtotal_price , (threshold * 100));
});

